export const environment = {
  production: false,
  /** Use '' so requests go to the dev server origin; `proxy.conf.json` forwards `/api` to the backend. */
  apiBaseUrl: '',
};
